// Généré par scripts/generate-flipt-types.js — NE PAS ÉDITER. Relancer : yarn flipt:types
export const FLAGS = {
  dashboardRh: 'dashboard-rh',
  dashboardRhModalEffectifTotal: 'dashboard-rh-modal-effectif-total',
  featureFlags: 'feature-flags',
  restartCameraServer: 'restart-camera-server',
  visioReviews: 'visio-reviews',
} as const

export type FlagKey = (typeof FLAGS)[keyof typeof FLAGS]

export interface FliptVariants {
  'dashboard-rh': never // flag booléen
  'dashboard-rh-modal-effectif-total': never // flag booléen
  'feature-flags': never // flag booléen
  'restart-camera-server': never // flag booléen
  'visio-reviews': never // flag booléen
}
